import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    timeUnitInput: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flexWrap: 'nowrap',
        '@media (max-width: 1024px)': {
            gap: '6px',
        },
    },
    label: {
        color: 'var(--colors-text-text-secondary-700), #344054',
        fontFamily: 'Be VietNam Pro',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '20px',
        whiteSpace: 'nowrap',
        '@media (max-width: 1024px)': {
            fontSize: '13px',
            lineHeight: '18px',
        },
    },
    numberInput: {
        width: '52px',
        '& .MuiInputBase-root': {
            height: '40px',
            borderRadius: '8px',
            border: '1px solid var(--Gray-300, #D0D5DD)',
            background: 'var(--Base-White, #FFF)',
            boxShadow: '0 1px 2px 0 rgba(16, 24, 40, 0.05)',
            '&:hover': {
                borderColor: 'var(--Gray-500, #98A2B3)',
            },
            '&.Mui-focused': {
                borderColor: 'var(--Gray-500, #98A2B3)',
                boxShadow: '0px 0px 0px 3px rgba(105, 65, 198, 0.1)',
            },
            '@media (max-width: 1024px)': {
                height: '36px',
            },
        },
        '& .MuiInputBase-input': {
            padding: '8px 12px',
            fontSize: '14px',
            textAlign: 'center',
            color: 'var(--Gray-900, #101828)',
            MozAppearance: 'textfield',
            '&::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0,
            },
            '&::-webkit-outer-spin-button': {
                WebkitAppearance: 'none',
                margin: 0,
            },
            '@media (max-width: 1024px)': {
                padding: '6px 10px',
                fontSize: '13px',
            },
        },
        '@media (max-width: 1024px)': {
            width: '48px',
        },
    },
    timeInput: {
        width: '100px',
        '& .MuiInputBase-root': {
            height: '40px',
            borderRadius: '8px',
            border: '1px solid var(--Gray-300, #D0D5DD)',
            background: 'var(--Base-White, #FFF)',
            boxShadow: '0 1px 2px 0 rgba(16, 24, 40, 0.05)',
            '&:hover': {
                borderColor: 'var(--Gray-500, #98A2B3)',
            },
            '&.Mui-focused': {
                borderColor: 'var(--Gray-500, #98A2B3)',
                boxShadow: '0px 0px 0px 3px rgba(105, 65, 198, 0.1)',
            },
            '@media (max-width: 1024px)': {
                height: '36px',
            },
        },
        '& .MuiInputBase-input': {
            padding: '8px 0px 8px 12px',
            fontSize: '14px',
            color: 'var(--Gray-900, #101828)',
            '@media (max-width: 1024px)': {
                padding: '6px 10px',
                fontSize: '13px',
            },
        },
        '& .MuiSvgIcon-root': {
            height: '20px',
            width: '20px',
        },
        '@media (max-width: 1024px)': {
            width: '90px',
        },
    },
    buttonGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
    },
    iconButton: {
        width: '36px',
        height: '18px',
        padding: '8px',
        boxSizing: 'border-box',
        borderRadius: '4px',
        border: '1px solid var(--Gray-300, #D0D5DD)',
        background: 'var(--Base-White, #FFF)',
        boxShadow: '0 1px 2px 0 rgba(16, 24, 40, 0.05)',
        '& svg': {
            fontSize: '12px',
            color: '#475467',
        },
        '&:hover': {
            opacity: 0.8,
            background: 'var(--Base-White, #FFF)',
        },
        '&:active': {
            transform: 'scale(0.95)',
        },
        '@media (max-width: 1024px)': {
            width: '32px',
            height: '16px',
            padding: '6px',
        },
    },
    select: {
        padding: '8px 32px 8px 12px',
        height: '40px',
        borderRadius: '8px',
        border: '1px solid var(--Gray-300, #D0D5DD)',
        background: 'var(--Base-White, #FFF)',
        fontSize: '14px',
        color: 'var(--Gray-900, #101828)',
        cursor: 'pointer',
        '& .MuiSelect-select': {
            padding: '0 !important',
        },
        '&:hover': {
            borderColor: 'var(--Gray-500, #98A2B3)',
        },
        '&.Mui-focused': {
            borderColor: 'var(--Gray-500, #98A2B3)',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        '@media (max-width: 1024px)': {
            padding: '6px 28px 6px 10px',
            height: '36px',
            fontSize: '13px',
        },
    },
}));

export { useStyles };

